import { render, staticRenderFns } from "./Hair16.vue?vue&type=template&id=a97289da&"
import script from "./Hair16.vue?vue&type=script&lang=js&"
export * from "./Hair16.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports